module.exports = __webpack_public_path__ + "static/media/main_slider_2.2cc1f8c0.jpg";